// extracted by mini-css-extract-plugin
export default {"content":"Home_content__qrD-+","boost":"Home_boost__rO85-","title":"Home_title__1aNQh"};